import React, { useEffect } from 'react';

const ThankYouPage = () => {
  // Google Ads conversion tracking event snippet
  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-16939224614/YwS1CMXT4KwaEKacoI0_',
        'value': 1.0,
        'currency': 'PKR'
      });
    }
  }, []);

  return (
    <div className="thank-you-container" 
         style={{ 
           backgroundImage: "url(assets/img/bg/client-bg1-1.png)",
           backgroundSize: "cover",
           backgroundPosition: "center",
           minHeight: "100vh",
           display: "flex",
           alignItems: "center",
           justifyContent: "center"
         }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="thank-you-card bg-theme" 
                 style={{ 
                   padding: "50px 30px",
                   borderRadius: "10px",
                   textAlign: "center",
                   boxShadow: "0 10px 30px rgba(0,0,0,0.1)"
                 }}>
              <div className="icon-container" 
                   style={{ 
                     margin: "0 auto 30px auto",
                     width: "80px",
                     height: "80px",
                     backgroundColor: "#fff",
                     borderRadius: "50%",
                     display: "flex",
                     alignItems: "center",
                     justifyContent: "center"
                   }}>
                <i className="fas fa-check-circle" 
                   style={{ 
                     fontSize: "40px",
                     color: "#28a745"
                   }}></i>
              </div>
              <h2 className="sec-text text-white" style={{ marginBottom: "20px" }}>Thank You!</h2>
              <p className="text-white" style={{ fontSize: "18px", marginBottom: "30px" }}>
                Thank you for your inquiry! Our representative will reach out to you shortly.
              </p>
              <a href="/" className="btn style3">
                Return to Home
                <i className="fas fa-arrow-right ms-2"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;